import { createContext } from 'react';

import { CategoricalBarChartValueAxisConfiguration } from '../types/categorical-bar-chart.js';
import { defaultConfig } from '../types/defaults.js';

export const CategoricalBarChartValueAxisContext =
  createContext<CategoricalBarChartValueAxisConfiguration>(
    defaultConfig.valueAxis,
  );
